import { Answer, AnswerRequest, Question } from '../dto/questionnaire.dto';
import toast from 'react-hot-toast';
import axios from 'axios';

export const handelValidateAnswer = (
  questions: Question[],
  answers: Answer[],
  questionAnswers?: { [key: string]: Answer },
) => {
  const answerCount = questions.filter(
    (question: Question) =>
      questionAnswers?.[question.id] || findAnswer(question.id, answers),
  ).length;
  const questionCount = questions.length;
  return answerCount === questionCount;
};

export const findAnswer = (questionId: string, answers: Answer[]) => {
  return answers?.find((answer: any) => answer.questionId == questionId);
};

export const mapAnswer = (
  currentAnswer: Answer,
  isShortAnswer: boolean,
  requestAnswer: Answer | undefined,
  question: Question,
  score: number | undefined,
) => {
  return {
    ...(currentAnswer && { id: currentAnswer.id }),
    value: isShortAnswer
      ? requestAnswer?.value ?? currentAnswer?.value
      : requestAnswer?.answerOptionId ?? currentAnswer?.answerOptionId,
    score: isShortAnswer ? score ?? currentAnswer?.score : 0,
    question_id: question?.id,
    answer_option_id: isShortAnswer
      ? question?.answerOptions?.[0]?.id ?? currentAnswer?.answerOptionId
      : requestAnswer?.answerOptionId ?? currentAnswer?.answerOptionId,
  };
};

export const questionnaireSubmit = (
  body: AnswerRequest,
  questions: Question[],
  answers: Answer[],
  questionAnswers?: { [key: string]: Answer },
  evaluationSubmit?: any,
) => {
  handelValidateAnswer(questions, answers, questionAnswers)
    ? evaluationSubmit(body)
    : toast.error('Please answer all questions in order to submit');
};
